export const HEADSHOT_PLACEHOLDER_LINK =
  'https://wpapi.plastlindenhurst.org/wp-content/uploads/2025/02/headshot-placeholder-1.png';
